// extracted by mini-css-extract-plugin
module.exports = {"list":"ActivitiesComments-list-1SYc6r20ln","commentHeader":"ActivitiesComments-commentHeader-30aFvjeAb7","commentList":"ActivitiesComments-commentList-3qccUg9b3l"};